import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './Svg.scss';

/* eslint-disable max-len,class-methods-use-this */
export class Svg extends Component {
  onClick = () => {
    if (this.props.onClick) {
      this.props.onClick();
    }
  };

  renderIcon(type) {
    switch (type) {
      case 'feedback':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M20 2H4c-1.1016 0-2 .8984-2 2v12c0 1.1016.8984 2 2 2h14l4 4V4c0-1.1016-.8984-2-2-2zm-2 5H6V5h12zm0 4H6V9h12zm-3 4H6v-2h9z" />
          </svg>
        );
      case 'success':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26">
            <path d="M22.5664 4.7305l-1.793-1.2188c-.496-.336-1.1757-.207-1.5078.2852l-8.789 12.961-4.0391-4.0391c-.4219-.422-1.1094-.422-1.5313 0l-1.5351 1.5351c-.4219.4219-.4219 1.1094 0 1.5352L9.582 22c.3476.3477.8945.6133 1.3866.6133.4922 0 .9883-.3086 1.3086-.7735L22.8555 6.2344c.336-.4922.207-1.168-.289-1.504z" />
          </svg>
        );
      case 'error':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
            <path
              fillRule="evenodd"
              d="M8 0C3.582 0 0 3.582 0 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zm2.721 9.359c.375.375.375.985 0 1.36-.376.375-.985.375-1.36 0l-1.359-1.36-1.359 1.36c-.375.375-.984.375-1.36 0-.375-.375-.375-.985 0-1.36L6.643 8l-1.36-1.359c-.375-.375-.375-.984 0-1.36.376-.375.985-.375 1.36 0l1.359 1.36 1.359-1.36c.375-.375.984-.375 1.36 0 .375.376.375.985 0 1.36L9.361 8l1.36 1.359z"
            />
          </svg>
        );
      case 'alert':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
            <path d="M15 3c-.8316 0-1.544.5067-1.8457 1.2285L2.3008 22.9473v.002A2 2 0 0 0 2 24a2 2 0 0 0 2 2 2 2 0 0 0 .1406-.0059l.004.0059h21.7109l.0039-.0078A2 2 0 0 0 26 26a2 2 0 0 0 2-2 2 2 0 0 0-.3008-1.0527l-.0156-.0274a2 2 0 0 0-.002-.002L16.8457 4.2286C16.5439 3.5067 15.8316 3 15 3zm-1.2129 8.3594h2.4258l-.2012 6.4726h-2.0234l-.2012-6.4726zm1.2168 8.4511c.822 0 1.3145.4423 1.3145 1.1973 0 .741-.4925 1.1817-1.3145 1.1817-.828 0-1.3242-.4407-1.3242-1.1817 0-.755.4952-1.1973 1.3242-1.1973z" />
          </svg>
        );
      case 'microphone':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M12 2c-1.6992 0-3 1.3008-3 3v7c0 1.6992 1.3008 3 3 3s3-1.3008 3-3V5c0-1.6992-1.3008-3-3-3zM5 12c0 3.5078 2.621 6.418 6 6.9063V22h2v-3.0938c3.379-.4882 6-3.3984 6-6.9062h-2c0 2.754-2.246 5-5 5s-5-2.246-5-5z" />
          </svg>
        );
      case 'note':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M12 2C6.4766 2 2 6.4766 2 12s4.4766 10 10 10 10-4.4766 10-10S17.5234 2 12 2zm1 15h-2v-6h2zm0-8h-2V7h2z" />
          </svg>
        );
      case 'link':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
            <path
              d="M37 4.004c-2.3047-.0002-4.6102.8782-6.3652 2.6327l-5 5c-2.492 2.492-3.2043 6.0906-2.1563 9.2266l3.5918-3.5918c.15-1.027.6036-2.0177 1.3926-2.8067l5-5C34.4379 8.4908 35.72 8.002 37 8.002c1.28 0 2.5612.4878 3.5352 1.4628 1.949 1.95 1.949 5.1214 0 7.0704l-5 5c-.789.789-1.7787 1.2415-2.8067 1.3925l-3.5937 3.5938c.928.31 1.8942.4746 2.8632.4746 2.305 0 4.6103-.8778 6.3653-2.6328l5-5c3.51-3.509 3.509-9.2176 0-12.7266C41.6083 4.8827 39.3047 4.004 37 4.004zm-6.039 12.9765a2.0002 2.0002 0 0 0-1.375.6054l-12 12a2.0002 2.0002 0 1 0 2.828 2.8282l12-12a2.0002 2.0002 0 0 0-1.453-3.4336zm-12.5118 6.043c-2.452-.1248-4.9427.7423-6.8125 2.6113l-5 5c-3.509 3.509-3.509 9.2195 0 12.7285C8.3917 45.1173 10.696 45.994 13 45.994c2.304 0 4.6083-.8778 6.3633-2.6328l5-5c2.492-2.492 3.2062-6.0905 2.1582-9.2265l-3.5938 3.5937c-.15 1.027-.6035 2.0177-1.3925 2.8067l-5 5c-1.949 1.95-5.1214 1.95-7.0704 0-1.949-1.95-1.949-5.1214 0-7.0704l5-5c.789-.789 1.7797-1.2435 2.8067-1.3945l3.5918-3.5918a9.0716 9.0716 0 0 0-2.414-.455z"
              overflow="visible"
            />
          </svg>
        );
      case 'resend':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26">
            <path d="M3 0C1.3437 0 0 1.3438 0 3v10c0 1.6563 1.3438 3 3 3h11.8125c1.2305-.875 2.5508-1.2695 3.6875-1.4375V13.5c0-.6094.2695-1.164.7188-1.5313L14.75 8.7813 12 10.5938 9.25 8.7813l-7.0313 5.0313 5.75-5.9063L1 2.4688l11 5.9375 11-5.9375-6.9688 5.4375 3.6876 3.7813c.7187-.293 1.6132-.082 2.0624.375l2.0626 1.8438C23.9336 13.621 24 13.3125 24 13V3c0-1.6563-1.3438-3-3-3zm17.5625 13.0625c-.0898-.0195-.1914-.004-.2813.0313-.1757.0742-.2812.246-.2812.4375v2.4062c-3.2266 0-7.5 1.5742-7.5 9.5625 1.4102-5.0977 3.3125-5.5 7.5-5.5v2.5c0 .1914.1055.3633.2813.4375.0585.0234.125.0313.1874.0313.1211 0 .254-.0665.3438-.1563l5-4.5a.4598.4598 0 0 0 0-.6563l-5-4.4687c-.0664-.0664-.1602-.1055-.25-.125z" />
          </svg>
        );
      case 'invite':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M12 0L3 5.4063c-.6016.3984-1 .9882-1 1.6875V18c0 1.1016.8984 2 2 2h16c1.1016 0 2-.8984 2-2V7.0937c0-.6992-.3984-1.3867-1-1.6875zm0 2.3125l7.9375 4.75L12 13 4.0625 7.0625zM11 5v2H9v2h2v2h2V9h2V7h-2V5z" />
          </svg>
        );
      case 'lock':
        return (
          <svg xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              d="M11 7V5c0-2.762-2.238-5-5-5S1 2.238 1 5v2c-.553 0-1 .447-1 1v7c0 .553.447 1 1 1h10c.553 0 1-.447 1-1V8c0-.553-.447-1-1-1zM9 7H3V5c0-1.654 1.346-3 3-3s3 1.346 3 3v2zm-3 7c-.552 0-1-.448-1-1v-3c0-.552.448-1 1-1s1 .448 1 1v3c0 .552-.448 1-1 1z"
            />
          </svg>
        );
      case 'minus':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="11" height="2">
            <path
              fillRule="evenodd"
              d="M10.5 2H.5C.224 2 0 1.776 0 1.5v-1C0 .224.224 0 .5 0h10c.276 0 .5.224.5.5v1c0 .276-.224.5-.5.5z"
            />
          </svg>
        );
      case 'plus':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10">
            <path
              fillRule="evenodd"
              d="M9.5 4H6V.5c0-.276-.224-.5-.5-.5h-1c-.276 0-.5.224-.5.5V4H.5c-.276 0-.5.224-.5.5v1c0 .276.224.5.5.5H4v3.5c0 .276.224.5.5.5h1c.276 0 .5-.224.5-.5V6h3.5c.276 0 .5-.224.5-.5v-1c0-.276-.224-.5-.5-.5z"
            />
          </svg>
        );
      case 'alertCircle':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
            <path d="M8 0C3.582 0 0 3.582 0 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zm1 12.5c0 .276-.224.5-.5.5h-1c-.276 0-.5-.224-.5-.5v-6c0-.276.224-.5.5-.5h1c.276 0 .5.224.5.5v6zm0-8c0 .276-.224.5-.5.5h-1c-.276 0-.5-.224-.5-.5v-1c0-.276.224-.5.5-.5h1c.276 0 .5.224.5.5v1z" />
          </svg>
        );
      case 'close':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26">
            <path d="M6.6563 4c-.2891 0-.5508.1133-.75.3125L4.3125 5.9063c-.3984.3984-.3984 1.0937 0 1.5937l5.5 5.5-5.5 5.5c-.3984.5-.3984 1.1953 0 1.5938l1.5938 1.5937c.5.3984 1.1953.3984 1.5937 0l5.5-5.5 5.5 5.5c.5.3984 1.1953.3984 1.5938 0l1.5937-1.5938c.3984-.5.3984-1.1953 0-1.5937l-5.5-5.5 5.5-5.5c.3984-.5.3984-1.1953 0-1.5938l-1.5938-1.5937c-.5-.3984-1.1953-.3984-1.5937 0l-5.5 5.5-5.5-5.5C7.25 4.1133 6.9453 4 6.6562 4z" />
          </svg>
        );
      case 'more':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="4">
            <path
              fillRule="evenodd"
              d="M14.4 3.6c-.884 0-1.6-.716-1.6-1.6 0-.884.716-1.6 1.6-1.6.884 0 1.6.716 1.6 1.6 0 .884-.716 1.6-1.6 1.6zM8 3.6c-.884 0-1.6-.716-1.6-1.6 0-.884.716-1.6 1.6-1.6.884 0 1.6.716 1.6 1.6 0 .884-.716 1.6-1.6 1.6zm-6.4 0C.716 3.6 0 2.884 0 2 0 1.116.716.4 1.6.4c.884 0 1.6.716 1.6 1.6 0 .884-.716 1.6-1.6 1.6z"
            />
          </svg>
        );
      case 'star':
        return (
          <svg xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              fill="ccd4d7"
              d="M12.426 15.899L8 13.462l-4.427 2.436c-.443.244-.736.031-.653-.478l.848-5.172L.207 6.615c-.356-.364-.243-.721.256-.795l4.914-.747L7.604.348c.219-.464.573-.464.792 0l2.227 4.725 4.913.747c.498.074.613.431.257.795l-3.562 3.633.848 5.172c.083.509-.209.723-.653.479z"
            />
          </svg>
        );
      case 'arrowBack':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
            <path d="M10.336 15.763c.303.318.792.318 1.092.001l1.091-1.147c.303-.315.303-.828 0-1.145l-5.26-5.448 5.304-5.494c.303-.316.303-.828 0-1.146L11.472.238c-.299-.315-.79-.315-1.092 0L3.434 7.45c-.299.318-.299.831 0 1.147l6.902 7.166z" />
          </svg>
        );
      case 'bell':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
            <path d="M15 9.305c0-3.322-2.125-6.118-5.03-7.006C9.984 2.2 10 2.102 10 2c0-1.105-.896-2-2-2S6 .895 6 2c0 .102.016.2.03.299C3.125 3.187 1 5.982 1 9.305V12H.5c-.276 0-.5.224-.5.5v1c0 .276.224.5.5.5H6c0 1.105.896 2 2 2s2-.895 2-2h5.5c.276 0 .5-.224.5-.5v-1c0-.276-.224-.5-.5-.5H15V9.305z" />
          </svg>
        );
      case 'cross':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
            <path d="M14.745 12.292L10.452 8l4.293-4.291a.8637.8637 0 0 0 0-1.227l-1.228-1.227c-.337-.337-.888-.337-1.225 0L8 5.548 3.708 1.255c-.338-.337-.887-.337-1.226 0L1.256 2.482a.8637.8637 0 0 0 0 1.227L5.548 8l-4.292 4.292c-.341.34-.341.888 0 1.226l1.226 1.227c.339.34.888.34 1.226 0L8 10.452l4.293 4.292c.337.34.888.34 1.225 0l1.228-1.227c.34-.337.34-.885-.001-1.225z" />
          </svg>
        );
      case 'arrow':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <path d="M15.762 5.664c.318-.303.318-.792.001-1.092l-1.147-1.091c-.315-.303-.828-.303-1.145 0l-5.448 5.26-5.494-5.304c-.316-.303-.828-.303-1.146 0L.237 4.528c-.315.299-.315.79 0 1.092l7.212 6.946c.318.299.831.299 1.147 0l7.166-6.902z" />
          </svg>
        );
      case 'arrowTop':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
            <path
              d="M16 4.0938l-6.7188 6.7187 1.4375 1.4063L15 7.9375V28h2V7.9375l4.2813 4.2813 1.4374-1.4063z"
              fill="#bbb"
            />
          </svg>
        );
      case 'arrowSmall':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6">
            <path
              fillRule="evenodd"
              d="M9.82 1.528c.198-.188.198-.494 0-.68l-.715-.68c-.197-.188-.516-.188-.713 0L4.999 3.446 1.576.141c-.199-.188-.518-.188-.715 0l-.714.68c-.197.187-.197.492 0 .68L4.64 5.828c.199.187.518.187.715 0l4.465-4.3z"
            />
          </svg>
        );
      case 'delete':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16">
            <path
              fillRule="evenodd"
              d="M13 3h-2V1c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v2H1c-.55 0-1 .45-1 1s.45 1 1 1v10c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V5c.55 0 1-.45 1-1s-.45-1-1-1zM5 2h4v1H5V2zm1 10.5c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-6c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v6zm4 0c0 .28-.22.5-.5.5h-1c-.281 0-.5-.22-.5-.5v-6c0-.28.219-.5.5-.5h1c.28 0 .5.22.5.5v6z"
            />
          </svg>
        );
      case 'spinning':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" version="1" width="32" height="32" viewBox="0 0 128 128">
            <g>
              <path d="M75.4 126.63a11.43 11.43 0 0 1-2.1-22.65 40.9 40.9 0 0 0 30.5-30.6 11.4 11.4 0 1 1 22.27 4.87h.02a63.77 63.77 0 0 1-47.8 48.05v-.02a11.38 11.38 0 0 1-2.93.37z" />
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 64 64"
                to="360 64 64"
                dur="1200ms"
                repeatCount="indefinite"
              />
            </g>
          </svg>
        );
      case 'arrowThin':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16">
            <path
              fillRule="evenodd"
              d="M8.818 8.496L1.1 15.791a.6343.6343 0 0 1-.918 0c-.253-.261-.253-.685 0-.946L7.435 7.99.182 1.134C-.071.873-.071.449.182.188a.6343.6343 0 0 1 .918 0l7.718 7.295c.135.139.193.324.184.507.009.182-.049.367-.184.506z"
            />
          </svg>
        );
      case 'user':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
            <path
              fillRule="evenodd"
              d="M15 16H1c-.552 0-1-.447-1-1v-1c0-1.894 1.687-3.537 4.171-4.385C5.211 10.479 6.545 11 8 11c1.454 0 2.789-.521 3.829-1.385C14.313 10.463 16 12.106 16 14v1c0 .553-.448 1-1 1zM8 9C5.791 9 4 7.209 4 5V4c0-2.209 1.791-4 4-4s4 1.791 4 4v1c0 2.209-1.791 4-4 4z"
            />
          </svg>
        );
      case 'dollar':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
            <path d="M9 3c.932 0 1.717.642 1.938 1.505.068.267.286.495.562.495h1c.276 0 .504-.226.469-.499C12.723 2.529 11.037 1 9 1V.5c0-.276-.224-.5-.5-.5h-1c-.276 0-.5.224-.5.5V1C4.794 1 3 2.794 3 5s1.794 4 4 4v4c-.932 0-1.717-.642-1.938-1.505C4.994 11.228 4.776 11 4.5 11h-1c-.276 0-.503.226-.469.499C3.277 13.471 4.963 15 7 15v.5c0 .276.224.5.5.5h1c.276 0 .5-.224.5-.5V15c2.205 0 4-1.794 4-4s-1.795-4-4-4V3zM5 5c0-1.103.897-2 2-2v4c-1.103 0-2-.897-2-2zm4 8V9c1.104 0 2 .897 2 2s-.896 2-2 2z" />
          </svg>
        );
      case 'refresh':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
            <path d="M7.005 13.919C4.371 13.411 2 10.957 2 8.016c0-1.49.55-2.885 1.506-3.959l.015-.01 1.708 1.708c.426.425.77.283.77-.318V.544A.544.544 0 0 0 5.455 0H.562C-.04 0-.181.344.242.769l1.86 1.86-.022.018C.757 4.093.001 5.99.001 8.016c0 4.044 3.358 7.396 6.999 7.927.547.08.998-.374.998-.927s-.452-.993-.993-1.097zm6.908-.529l.041-.032c1.305-1.449 2.048-3.338 2.048-5.342 0-4.044-3.365-7.396-7.006-7.927-.547-.08-.998.374-.998.927s.452.992.994 1.096c2.636.508 5.009 2.962 5.009 5.903 0 1.47-.535 2.854-1.476 3.933l-.03.023-1.728-1.727c-.425-.425-.769-.283-.769.318v4.893c0 .301.243.544.544.544h4.892c.603 0 .744-.344.32-.769l-1.841-1.84z" />
          </svg>
        );
      case 'info':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
            <path
              fillRule="evenodd"
              d="M8 0C3.582 0 0 3.582 0 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zm1 12.5c0 .276-.224.5-.5.5h-1c-.277 0-.5-.224-.5-.5v-6c0-.277.223-.5.5-.5h1c.276 0 .5.223.5.5v6zm0-8c0 .276-.224.5-.5.5h-1c-.277 0-.5-.224-.5-.5v-1c0-.277.223-.5.5-.5h1c.276 0 .5.223.5.5v1z"
            />
          </svg>
        );
      case 'comments':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
            <path d="M9 4.009H1c-.55 0-1 .461-1 1.026v6.001c0 .564.45 1.004 1 1.004h1v3.341c0 .566.531.832.902.44L6.28 12.04H9c.55 0 1-.44 1-1.004V5.035c0-.565-.45-1.026-1-1.026zm6-4.016H7c-.55 0-1 .461-1 1.026v1.986h4c.553 0 1 .449 1 1.004v5.448l2.098 2.349c.371.391.902.126.902-.441V8.024h1c.55 0 1-.44 1-1.004V1.019c0-.564-.45-1.026-1-1.026z" />
          </svg>
        );
      case 'users':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26">
            <path d="M17.5313 1c-1.797 0-3.3672.9258-4.0626 2.6875 1.461 1.2031 2.4688 3.0664 2.4688 5.5938 0 2.6953-1.2734 5.1601-2.5938 6.75 2.1055.7968 5.4024 2.3945 6.3438 4.8437 3.3164-.1836 6.2813-.8516 6.2813-2.75V17.5c0-1.7383-3.0352-3.4414-5.7188-4.3438-.121-.039-.8906-.2265-.4063-1.7187 1.2618-1.3164 2.125-3.4453 2.125-5.5313C21.9688 2.6953 19.9728 1 17.5313 1zM8.9687 4.0938c-2.6015 0-4.8437 1.7773-4.8437 5.1875 0 2.2304 1.0586 4.5078 2.4063 5.9062.5234 1.3984-.4297 2.3945-.625 2.4688C3.1875 18.6522 0 20.453 0 22.25v.6875c0 2.4492 4.6719 3 9 3 4.336 0 8.9688-.5508 8.9688-3V22.25c0-1.8516-3.207-3.6328-6.0626-4.5938-.1328-.043-.953-.914-.4375-2.5h-.0312c1.3398-1.4023 2.5-3.6523 2.5-5.875 0-3.4101-2.371-5.1875-4.9688-5.1875z" />
          </svg>
        );
      case 'company':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
            <path d="M15 3H9V1c0-.553-.447-1-1-1H1C.447 0 0 .447 0 1v14c0 .553.447 1 1 1h14c.553 0 1-.447 1-1V4c0-.553-.447-1-1-1zM4 10H2V8h2v2zm0-3H2V5h2v2zm0-3H2V2h2v2zm3 6H5V8h2v2zm0-3H5V5h2v2zm0-3H5V2h2v2zm4 6H9V8h2v2zm0-3H9V5h2v2zm3 3h-2V8h2v2zm0-3h-2V5h2v2z" />
          </svg>
        );
      case 'menu':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
            <path d="M6 0H1C.448 0 0 .447 0 1v5c0 .553.448 1 1 1h5c.552 0 1-.447 1-1V1c0-.553-.448-1-1-1zm0 9H1c-.552 0-1 .447-1 1v5c0 .553.448 1 1 1h5c.552 0 1-.447 1-1v-5c0-.553-.448-1-1-1zm9 0h-5c-.553 0-1 .447-1 1v5c0 .553.447 1 1 1h5c.553 0 1-.447 1-1v-5c0-.553-.447-1-1-1zm0-9h-5c-.553 0-1 .447-1 1v5c0 .553.447 1 1 1h5c.553 0 1-.447 1-1V1c0-.553-.447-1-1-1z" />
          </svg>
        );
      case 'drops':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
            <path d="M16 6.488l-.181.265.005.004-1.214 1.776-.008-.002-.005.006-1.776-1.214.003-.007-1.702-1.165-2.882 4.22.003.004-1.215 1.777-.005-.004-.003.004-1.778-1.215.004-.004L2.811 9.27 0 13.242V9.59l2.262-3.308 1.777 1.214-.002.003 2.425 1.657 4.103-6.004 1.776 1.214-.005.007 1.72 1.175L16 2.758v3.73z" />
          </svg>
        );
      case 'trash':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
            <path d="M14 3h-2V1c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v2H2c-.55 0-1 .45-1 1s.45 1 1 1v10c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V5c.55 0 1-.45 1-1s-.45-1-1-1zM6 2h4v1H6V2zm1 10.5c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-6c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v6zm4 0c0 .28-.22.5-.5.5h-1c-.28 0-.5-.22-.5-.5v-6c0-.28.22-.5.5-.5h1c.28 0 .5.22.5.5v6z" />
          </svg>
        );
      case 'gear':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
            <path
              fillRule="evenodd"
              d="M15 7h-1.09c-.15-.91-.5-1.75-1.02-2.471l.76-.769c.39-.39.39-1.03 0-1.42a.9959.9959 0 0 0-1.41 0l-.77.769C10.75 2.59 10 2.24 9 2.09V1c0-.55-.45-1-1-1S7 .45 7 1v1.09c-1 .15-1.75.5-2.47 1.019l-.77-.769c-.389-.39-1.03-.39-1.42 0-.39.39-.39 1.03 0 1.42l.77.769C2.59 5.25 2.24 6.09 2.09 7H1c-.55 0-1 .48-1 1.029C0 8.58.45 9 1.12 9h.97c.15.91.5 1.75 1.02 2.471l-.77.769c-.39.39-.39 1.029 0 1.42.39.39 1.02.39 1.41 0l.78-.77c.72.52 1.47.87 2.47 1.02V15c0 .55.45 1 1 1s1-.45 1-1v-1.09c1-.15 1.75-.5 2.47-1.02l.77.77c.391.39 1.02.39 1.41 0 .39-.391.39-1.03 0-1.42l-.76-.76c.51-.72.87-1.56 1.02-2.48H15c.55 0 1-.45 1-1s-.45-1-1-1zm-7 4c-1.66 0-3-1.35-3-3 0-1.651 1.34-3 3-3 1.65 0 3 1.349 3 3 0 1.65-1.35 3-3 3z"
            />
          </svg>
        );
      case 'calendar':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
            <path
              fillRule="evenodd"
              d="M14.9 1H13V.5c0-.277-.324-.5-.6-.5h-1c-.277 0-.4.223-.4.5V1H9V.5c0-.277-.224-.5-.5-.5h-1c-.276 0-.5.223-.5.5V1H5V.5c0-.277-.124-.5-.4-.5h-1c-.277 0-.6.223-.6.5V1H1.1C.548 1 0 1.447 0 2v13c0 .553.548 1 1.1 1h13.8c.552 0 1.1-.447 1.1-1V2c0-.553-.548-1-1.1-1zM5 14H3v-2h2v2zm0-4H3V8h2v2zm4 4H7v-2h2v2zm0-4H7V8h2v2zm4 4h-2v-2h2v2zm0-4h-2V8h2v2zm1-4H2V3h1v.5c0 .276.323.5.6.5h1c.276 0 .4-.224.4-.5V3h2v.5c0 .276.224.5.5.5h1c.276 0 .5-.224.5-.5V3h2v.5c0 .276.123.5.4.5h1c.276 0 .6-.224.6-.5V3h1v3z"
            />
          </svg>
        );
      case 'circle':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="4 4 16 16">
            <path
              fill="none"
              stroke="/000000"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M17.727 10.727C17.727 15.18 12 19 12 19s-5.727-3.82-5.727-8.273C6.273 7.564 8.838 5 12 5c3.165 0 5.727 2.564 5.727 5.727z"
            />
            <circle cx="12" cy="11" r="2.5" />
          </svg>
        );
      default:
        return null;
    }
  }

  render() {
    const { className } = this.props;

    return (
      <span className={classNames(className, styles.wrapper)} onClick={this.onClick}>
        {this.renderIcon(this.props.type)}
      </span>
    );
  }
}
/* eslint-enable max-len */

Svg.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string.isRequired,
  onClick: PropTypes.string,
};

Svg.defaultProps = {
  className: null,
  onClick: null,
};

export default Svg;



// WEBPACK FOOTER //
// ./src/components/atoms/Svg/svg.js